import JSXComponent from "../../dist/jsx-render/JSXComponent";
import dom from "../../dist/jsx-render/dom"
import { DynPopup } from "../Components/DynPopup";
import { app } from "./App";
import { ITreeItem } from "../Controls/Dynamic/ITreeItem";
import { MeasureEditFactory } from "../Pages/Measure/MeasureEditFactory";
import { PopupCloseType } from "../Controls/PagePopup";

export type PopupOriginalComponentProps = {
    items: ITreeItem[];
    templateId: number;
    templateFieldId: number;
    onItemClicked?: (itemId: number) => void;
}

export class PopupOriginalComponent extends JSXComponent {
    props: PopupOriginalComponentProps;

    constructor(props: PopupOriginalComponentProps) {
        super(props);
    }

    public static create(templateId: number, templateFieldId: number, onItemClicked?: (itemId: number) => void) {
        app.showWaitPanel();
        $.get(app.resolveUrl(`~/api/measure/getOriginals/${templateId}/${templateFieldId}`), (items: ITreeItem[]) => {
            app.hideWaitPanel();
            document.body.appendChild(<PopupOriginalComponent items={items} templateId={templateId} templateFieldId={templateFieldId} onItemClicked={onItemClicked} />);
        }).fail((resp) => {
            app.hideWaitPanel();
            alert(resp.responseText)
        });
    }

    onCancel = (): boolean => {
        if (this.props.templateFieldId == 0) {
            app.openNewMeasurePopup(this.props.templateId);
        }
        return true;
    }

    renderTree(): HTMLElement[] {
        let result: HTMLElement[] = [];

        for (let item of this.props.items) {
            let div: HTMLElement = <div class="d-flex flex-row align-items-center original-collapse pointer"><i class="fas fa-caret-right mr-1"></i><span class="font-weight-bolder">{item.text}</span></div>;
            let childDiv: HTMLElement = <div class="d-none flex-column original-childs ml-3"></div>
            result.push(div);
            result.push(childDiv);

            let childItems = this.renderFlat(item.children);
            for (let element of childItems) {
                childDiv.appendChild(element);
            }

            div.addEventListener("click", () => {
                if (childDiv.classList.contains("d-none")) {
                    childDiv.classList.remove("d-none");
                    childDiv.classList.add("d-flex");
                    div.firstElementChild.classList.remove("fa-caret-right");
                    div.firstElementChild.classList.add("fa-caret-down");
               }
                else {
                    childDiv.classList.add("d-none");
                    childDiv.classList.remove("d-flex");
                    div.firstElementChild.classList.add("fa-caret-right");
                    div.firstElementChild.classList.remove("fa-caret-down");
                }
            });
        }

        return result;
    }

    renderFlat(items: ITreeItem[]): HTMLElement[] {
        let result: HTMLElement[] = [];

        for (let item of items) {
            let div: HTMLElement = <div class="d-flex flex-row original-item pointer" data-id={item.id}>{item.text}</div>;
            result.push(div);

            div.addEventListener("click", () => {
                if (this.props.templateFieldId == 0) {
                    app.showWaitPanel();
                    $.get(app.resolveUrl(`~/api/measure/copyOriginal/${item.id}`), (newId: number) => {
                        app.hideWaitPanel();
                        this.element.parentElement.removeChild(this.element);
                        MeasureEditFactory.showMeasure({
                            measureId: newId,
                            templateId: this.props.templateId,
                            parentId: 0,
                            parentGuid: "",
                            fullScreen: true,
                            onClose: ((reason: PopupCloseType, id: number) => {
                                app.dispatchOnNewMeasureCreated(reason, id);
                            })
                        });
                    }).fail((resp) => {
                        app.hideWaitPanel();
                        alert(resp.responseText)
                    });
                }
                else {
                    if (this.props.onItemClicked) {
                        this.props.onItemClicked(parseInt(item.id));
                    }
                }
            });
        }

        return result;
    }

    renderItems(): HTMLElement[] {
        let hasChilds = false;
        for (let item of this.props.items) {
            if (item.children && item.children.length > 0) {
                hasChilds = true;
            }
        }
        if (hasChilds) {
            return this.renderTree();
        }
        else {
            return this.renderFlat(this.props.items);
        }
    }

    element: HTMLElement =
        <DynPopup size="fit"
            showCancelButton={true}
            onCancel={this.onCancel}
            cssClass="original-select-popup"
            title={Resources.Common.originalPopupTitle}>
            <div class="d-flex flex-column">
                {...this.renderItems()}
            </div>
        </DynPopup>

    render(): HTMLElement {

        return this.element;
    }
}
